import { useState, useEffect, useCallback } from "react";
import { Input, InputGroup, InputGroupAddon } from "reactstrap";
import currencyToSymbolMap from "currency-symbol-map/map";
import _ from "underscore";
import getSymbolFromCurrency from "currency-symbol-map";

import Constants from "../../utils/Constants";
import NumberUtils from "../../utils/NumberUtils";
import { callFunctionIfExists } from "../../utils/GeneralUtils";

const CurrencyInterval = ({
  field,
  existingValue,
  onChange,
  inputSize,
  disabled,
}) => {
  const [Value, setValue] = useState("");
  const [Currency, setCurrency] = useState(
    existingValue?.Currency ? existingValue?.Currency : "USD"
  );
  const [Interval, setInterval] = useState(
    existingValue?.Interval ? existingValue?.Interval : "mo"
  );

  const updateValue = useCallback(() => {
    if (typeof existingValue === "string") return setValue("");

    if (
      existingValue?.Value === null ||
      existingValue?.Value === undefined ||
      existingValue === null ||
      existingValue === undefined
    ) {
      return setValue("");
    }

    if (existingValue?.Value === 0) {
      setValue(0);
    } else {
      setValue(
        !isNaN(existingValue?.Value) && existingValue?.Value
          ? parseFloat(existingValue?.Value)
          : ""
      );
    }
    setCurrency(existingValue?.Currency || "USD");
    setInterval(existingValue?.Interval || "mo");
  }, [existingValue]);

  const handleChange = (payload, type, value) => {
    payload.CalculatedValues = {
      sec: NumberUtils.currencyIntervalAtoB(
        type === "Value" ? value : parseFloat(Value),
        type === "Interval" ? value : Interval,
        Constants.CURRENCY_INTERVALS.SECOND
      ),
      min: NumberUtils.currencyIntervalAtoB(
        type === "Value" ? value : parseFloat(Value),
        type === "Interval" ? value : Interval,
        Constants.CURRENCY_INTERVALS.MINUTE
      ),
      hr: NumberUtils.currencyIntervalAtoB(
        type === "Value" ? value : parseFloat(Value),
        type === "Interval" ? value : Interval,
        Constants.CURRENCY_INTERVALS.HOUR
      ),
      day: NumberUtils.currencyIntervalAtoB(
        type === "Value" ? value : parseFloat(Value),
        type === "Interval" ? value : Interval,
        Constants.CURRENCY_INTERVALS.DAY
      ),
      wk: NumberUtils.currencyIntervalAtoB(
        type === "Value" ? value : parseFloat(Value),
        type === "Interval" ? value : Interval,
        Constants.CURRENCY_INTERVALS.WEEK
      ),
      mo: NumberUtils.currencyIntervalAtoB(
        type === "Value" ? value : parseFloat(Value),
        type === "Interval" ? value : Interval,
        Constants.CURRENCY_INTERVALS.MONTH
      ),
      qtr: NumberUtils.currencyIntervalAtoB(
        type === "Value" ? value : parseFloat(Value),
        type === "Interval" ? value : Interval,
        Constants.CURRENCY_INTERVALS.QUARTER
      ),
      yr: NumberUtils.currencyIntervalAtoB(
        type === "Value" ? value : parseFloat(Value),
        type === "Interval" ? value : Interval,
        Constants.CURRENCY_INTERVALS.YEAR
      ),
    };

    callFunctionIfExists(onChange, payload);
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;

    let currency, interval;

    if (name === "Currency") {
      currency = value;
      interval = Interval;
      setCurrency(value);
    }

    if (name === "Interval") {
      currency = Currency;
      interval = value;
      setInterval(value);
    }

    let payload = {
      Value: parseFloat(Value),
      Currency: currency,
      Interval: interval,
      Symbol: getSymbolFromCurrency(Currency),
    };

    handleChange(payload, name, value);
  };

  const handleValueChange = (e) => {
    setValue(e.target.value);
    let newValue = e.target.value || null;
    newValue = newValue ? parseFloat(newValue) : null;

    let payload = {
      Value: newValue,
      Currency: Currency,
      Symbol: getSymbolFromCurrency(Currency),
      Interval: Interval,
    };

    handleChange(payload, "Value", newValue);
  };

  useEffect(() => {
    updateValue();
  }, [updateValue]);

  const getCurrencyCodes = () => _.keys(currencyToSymbolMap);

  return (
    <>
      <InputGroup>
        <InputGroupAddon style={{ height: "32px" }} addonType="prepend">
          {getSymbolFromCurrency(Currency)}
        </InputGroupAddon>
        <Input
          id={`record-input-${field.APIName}`}
          style={{ height: "32px" }}
          onChange={handleValueChange}
          required={field?.Required}
          bsSize={inputSize ? inputSize : ""}
          value={Value}
          disabled={disabled}
        ></Input>
        <InputGroupAddon addonType="append">
          <Input
            name="Currency"
            value={Currency}
            onChange={handleSelectChange}
            style={{
              height: "32px",
              width: "70px",
              textOverflow: "ellipsis",
            }}
            bsSize="sm"
            type="select"
            className="form-control"
            disabled={disabled}
          >
            <option disabled={true} value="">
              Choose A Currency
            </option>
            {getCurrencyCodes().map((f, i) => (
              <option key={i} value={f}>
                {f}
              </option>
            ))}
          </Input>
        </InputGroupAddon>
        <InputGroupAddon addonType="append">
          <Input
            name="Interval"
            required={true}
            value={Interval}
            onChange={handleSelectChange}
            style={{
              height: "32px",
              width: "90px",
              textOverflow: "ellipsis",
            }}
            bsSize="sm"
            type="select"
            className="form-control"
            disabled={disabled}
          >
            <option disabled={true} value="">
              Choose An Interval
            </option>
            <option value="sec">/ sec.</option>
            <option value="min">/ min.</option>
            <option value="hr">/ hr.</option>
            <option value="day">/ day.</option>
            <option value="wk">/ wk.</option>
            <option value="mo">/ mo.</option>
            <option value="qtr">/ qtr.</option>
            <option value="yr">/ yr.</option>
          </Input>
        </InputGroupAddon>
      </InputGroup>
    </>
  );
};

export default CurrencyInterval;
